const cleanBasePath = (value) => String(value || "").trim() === "/pharmacy/messages" ? "/pharmacy/messages" : "/messages";

export function messageEntryRoute(basePath, destination) {
  const base = cleanBasePath(basePath);
  return destination === "fola" ? `${base}/fola` : base;
}

export function messageEntryState(destination) {
  return destination === "fola"
    ? { conversationTitle: "Fola", conversationType: "fola" }
    : { forceInbox: true, compose: true };
}

// Entry routing is never a submit. Only an explicit send intent may ask for a
// non-empty composer value; attachment-only messages remain valid sends.
export function sendValidationError({ intent, draft, hasAttachment = false } = {}) {
  if (intent !== "send") return "";
  return String(draft || "").trim() || hasAttachment ? "" : "message_required";
}
